import { api } from "./api";

export const cjNav = async () => (await api.get("/cj/nav")).data;
export const cjFeed = async (feed, size = 12) => (await api.get(`/cj/feed/${feed}`, { params: { size } })).data;
export const cjCollection = async (handle, params = {}) =>
  (await api.get(`/cj/collection/${handle}`, { params })).data;
export const cjSearch = async (params = {}) => (await api.get("/cj/search", { params })).data;
export const cjProduct = async (handle) => (await api.get(`/cj/product/${handle}`)).data;

export const FEEDS = [
  { key: "flash-deals", label: "Flash Deals" },
  { key: "best-sellers", label: "Best Sellers" },
  { key: "new-arrivals", label: "New Arrivals" },
  { key: "trending", label: "Trending Now" },
  { key: "recently-added", label: "Recently Added" },
  { key: "recommended", label: "Recommended For You" },
];
